import styled from 'styled-components'

export const ButtonsContainer = styled.div`
  display: grid;
  gap: 16px;
  align-content: center;
  grid-template-rows: repeat(auto-fit, minmax(0, min-content));
  height: calc(100vh - 144px);
`